"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSeerLevelsFromSensor = exports.DEFAULT_SEER_LEVELS = void 0;
exports.DEFAULT_SEER_LEVELS = {
    minValue: 0,
    midValue: 8,
    maxValue: 16,
};
function getSeerLevelsFromSensor(hvacSensors) {
    if (!hvacSensors || hvacSensors.length === 0) {
        console.log('No HVAC sensors found, using default SEER levels:', exports.DEFAULT_SEER_LEVELS);
        return exports.DEFAULT_SEER_LEVELS;
    }
    const airHandlerSensor = hvacSensors.find((sensor) => sensor.type === 'HVAC_AIRHANDLER_MONITOR');
    if (!airHandlerSensor) {
        console.log('No air handler sensor found, using default SEER levels:', exports.DEFAULT_SEER_LEVELS);
        return exports.DEFAULT_SEER_LEVELS;
    }
    const seerMid = airHandlerSensor.seerMid;
    const seerMax = airHandlerSensor.seerMax;
    if (typeof seerMid === 'number' &&
        typeof seerMax === 'number' &&
        seerMid > 0 &&
        seerMax > seerMid) {
        const configuredLevels = {
            minValue: 0,
            midValue: seerMid,
            maxValue: seerMax,
        };
        return configuredLevels;
    }
    console.log(`Invalid SEER configuration on sensor ${airHandlerSensor.id} (seerMid: ${seerMid}, seerMax: ${seerMax}), using defaults:`, exports.DEFAULT_SEER_LEVELS);
    return exports.DEFAULT_SEER_LEVELS;
}
exports.getSeerLevelsFromSensor = getSeerLevelsFromSensor;
